/* eslint-disable @typescript-eslint/no-explicit-any */
import {cloneElement} from "react";
import pxToRem from "hooks/usePxToRem";

import {
  Divider,
  Typography,
  IconButton,
  Stack,
  Box,
  ButtonProps,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import useRoutesGoBack from "hooks/useRoutesGoBack";
import NIALauncher from "components/NIA/NIALauncher";

interface PageTitleProps {
  title: string;
  subtitle: string;
  actionButton?: React.ReactElement<ButtonProps>;
  goBackFunction?: () => void;
  chip?: JSX.Element;
  dividerShadow?: JSX.Element;
  isSidebarOpen?: boolean;
}

const PageTitle = (props: PageTitleProps) => {
  const goBack = useRoutesGoBack();

  const {
    title,
    subtitle,
    actionButton,
    goBackFunction = () => goBack(),
    chip,
    dividerShadow,
    isSidebarOpen,
  } = props;

  return (
    <Stack
      justifyContent="center"
      sx={{
        position: "relative",
        height: pxToRem(78),
        width: "100%",
        paddingRight: isSidebarOpen ? pxToRem(24) : pxToRem(0),
      }}
    >
      <Stack direction={"row"} alignItems="center">
        <Stack direction="row" sx={{width: "100%"}}>
          <IconButton onClick={goBackFunction} disableRipple>
            <ArrowBackIosIcon fontSize="large" color="primary" />
          </IconButton>

          <Box sx={{width: "100%"}}>
            <Typography
              variant="subtitle2"
              component="span"
              display="block"
              color="text.secondary"
              sx={{
                textTransform: "lowercase",
                "&:first-letter": {textTransform: "uppercase"},
              }}
            >
              {subtitle}
            </Typography>

            <Typography
              component="strong"
              color="primary"
              sx={{
                textTransform: "uppercase",
                fontSize: pxToRem(24),
                fontWeight: 700,
                lineHeight: 1.3,
              }}
            >
              {title}
            </Typography>
          </Box>
        </Stack>
        <Stack
          direction="row"
          alignItems={"center"}
          justifyContent="flex-end"
          gap={pxToRem(8)}
          sx={{width: 0, position: "relative"}}
        >
          {actionButton &&
            cloneElement(actionButton, {
              size: "small",
              variant: "contained",
              sx: {
                textTransform: "capitalize",
                minHeight: pxToRem(47),
                minWidth: pxToRem(108),
              },
            })}{" "}
          <Box>
            <NIALauncher />
          </Box>
        </Stack>
      </Stack>

      <Box
        sx={{
          position: "absolute",
          top: chip ? pxToRem(77 - 16) : pxToRem(77),
          left: pxToRem(-25),
          width: `calc(100% + ${pxToRem(isSidebarOpen ? 25 : 50)})`,
        }}
      >
        {dividerShadow}
        <Divider sx={{"& .MuiDivider-wrapper": {zIndex: 6}}}>{chip}</Divider>
      </Box>
    </Stack>
  );
};

export default PageTitle;
